import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { birdBaths, yardPieces, PieceCard, YardTourButton } from "@/components/site/availableCatalog";

const byId = (t) => yardPieces.find((p) => p.testid === t);
const teaserPieces = [
  byId("available-cherub-petal-fountain"),
  byId("available-buddha-bowl"),
  byId("available-baby-elephant"),
  byId("available-garden-gnome"),
  byId("available-cherub-shell-dish"),
  byId("available-rose-lady-bust"),
].filter(Boolean);

export default function AvailablePieces() {
  return (
    <section
      id="available"
      data-testid="available-section"
      className="bg-[#F9F6F0] py-10 md:py-14 border-t border-[#D5CEBD]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-10 md:mb-12">
          <div>
            <div className="section-eyebrow mb-5">
              <span>The Collection</span>
            </div>
            <h2
              data-testid="available-heading"
              className="font-serif font-light text-[#2C2A28] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl"
            >
              Explore our pieces.
            </h2>
          </div>
          <p className="text-[#5C5955] max-w-md text-sm md:text-base leading-relaxed">
            Handcrafted fountains, statues, and planters. Ask about current
            availability.
          </p>
        </div>

        <div className="mb-10">
          <YardTourButton />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-testid="available-teaser-grid">
          {teaserPieces.map((p) => (
            <PieceCard key={p.testid} piece={p} />
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/available-now"
            data-testid="available-see-all"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#1F1E1C] text-[#F9F6F0] text-[11px] tracking-[0.22em] uppercase hover:bg-[#7A6547] transition-colors"
          >
            Browse Available Pieces
            <ArrowRight size={14} strokeWidth={1.5} />
          </Link>
          <p data-testid="available-inventory-note" className="mt-5 text-xs text-[#6F6A60] leading-relaxed max-w-md mx-auto">
            Inventory moves faster than the website. A piece shown here may already be spoken for, so inquire and Chris will confirm.
          </p>
        </div>
      </div>
    </section>
  );
}
